import {Component, Input, OnInit} from '@angular/core';
import {Constant} from '../../../shared/constants/constant.class';
import {AuthService} from '../../../service/auth.service';
import {Router} from '@angular/router';
import {VekoAccount} from '../../../model/account';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { GeneralService } from 'src/app/service/general-service';
import { AppConfigService } from 'src/app-config.service';
import { NotificationService } from 'src/app/service/notification.service';

@Component({
  selector: "app-topbar",
  templateUrl: "./topbar.component.html",
  styleUrls: ["./topbar.component.scss"],
})
export class TopbarComponent implements OnInit {
  extrasUserDisplay: boolean;
  extrasUserLayout: "offcanvas" | "dropdown";
  _user: VekoAccount;
  extrasNotificationsDisplay: boolean;
  isVisibleUpdate: boolean = false;
  form: FormGroup;
  passwordVisible: boolean;
  repeatpasswordVisible: boolean;
  isVisiblePassword: boolean;
  submitted = false;
  allRoles: any[];
  urlServiceSignature: String = "";
  signature: any = {};
  currentUser: any;

  @Input() layoutType: any;
  constructor(
    private authService: AuthService,
    private route: Router,
    private fb: FormBuilder,
    private generalService: GeneralService,
    private configService: AppConfigService,
    private notificationService: NotificationService
  ) {
    this.extrasNotificationsDisplay = true;
    this.form = this.fb.group({
      id: [null],
      fullname: [null],
      username: [null],
      phoneNo: [null],
      email: [null],
      password: [null],
      repeatPassword: [null],
      roles: [null],
      signatureImageUrl: [null, [Validators.required]],
      userType: [null]
    });
    this.signature = {
      Authorization: "Bearer " + localStorage.getItem(Constant.TOKEN),
    };
    this.urlServiceSignature =
      this.configService.getConfig().api.baseUrl + `/Upload/UploadFile`;
  }

  ngOnInit(): void {
    this._user = JSON.parse(localStorage.getItem(Constant.USER_INFO));
    this.getCurrentUser(this._user.id);
    this.extrasUserLayout = "dropdown";
  }

  getAllRole() {
    this.generalService.getRole().subscribe(
      (res) => {
        if (res !== null) {
          this.allRoles = res;
        }
      },
      (error) => {}
    );
  }

  getCurrentUser(id) {
    this.generalService.getDetailTaikhoan(id).subscribe(
      (res) => {
        if (res !== null) {
          this.currentUser = res;
        }
      },
      (error) => {}
    );
  }

  get f() {
    return this.form.controls;
  }

  logout() {
    const fcmToken = localStorage.getItem(Constant.FIREBASE_TOKEN);
    if (fcmToken) {
      this.generalService.deleteToken(fcmToken).subscribe({
        next: () => {
          localStorage.removeItem(Constant.FIREBASE_TOKEN);
          console.log('[FCM] Đã xóa token khỏi BE ✅');
        }
      });
    }
    localStorage.removeItem(Constant.TOKEN);
    localStorage.removeItem(Constant.USER_INFO);
    localStorage.removeItem(Constant.FIREBASE_TOKEN);
    this.route.navigate([`/admin-login`]);
    /*this.authService.logout().subscribe(res => {
      localStorage.removeItem(Constant.TOKEN);
      localStorage.removeItem(Constant.USER_INFO);
      this.route.navigate([Constant.LOGIN]);
      if (this.layoutType === "ADMIN")
        this.route.navigate([Constant.LOGIN]);
      /!*else if (this.layoutType === 'PORTAL')
        this.route.navigate([Constant.LOGIN]);
      else if (this.layoutType === 'CSC')
        this.route.navigate(['/csc-login']);*!/
    });*/
  }

  getRoles(userRole) {
    var s = [];
    for (var i = 0; i < userRole.length; i++) {
      s[i] = userRole[i].roleId;
    }
    return s;
  }

  showModalUpdate() {
    this.isVisibleUpdate = true;
    this.form.patchValue({
      id: this.currentUser.id,
      fullname: this.currentUser.fullname,
      username: this.currentUser.username,
      phoneNo: this.currentUser.phoneNo,
      email: this.currentUser.email,
      roles: this.getRoles(this.currentUser.userRoles),
      signatureImageUrl: this.currentUser.signatureImageUrl,
      userType: this.currentUser.userType
    });
  }

  handleCancel() {
    this.isVisibleUpdate = false;
  }

  handleOk() {
    const formValue = this.form.value;
    this.generalService.updateTaikhoan(formValue).subscribe(
      (res) => {
        if (res.ret && res.ret[0].code !== 0) {
          this.notificationService.showNotification(
            Constant.ERROR,
            res.ret[0].message
          );
        } else {
          this.isVisibleUpdate = false;
          this.notificationService.showNotification(
            Constant.SUCCESS,
            Constant.MESSAGE_UPDATE_SUCCESS
          );
        }
      },
      (error) => {}
    );
  }
}
